import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Typography,
  Button,
  InputNumber,
  Popconfirm,
  Space,
  Select,
  Modal,
  Divider,
  AutoComplete,
  Tabs,
  Upload,
  Radio,
  DatePicker,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";
import {
  DeleteOutlined,
  PlusOutlined,
  EditOutlined,
  InfoCircleOutlined,
  UnorderedListOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  WalletOutlined,
  BankOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { QuotationService } from "../../../../Services/Manage/QuotationService";
import { ServicetypeService } from "../../../../Services/Manage/ServicetypeService";
import { LetterService } from "../../../../Services/Manage/LetterService";
import { BankService } from "../../../../Services/Manage/BankService";
import AddBankData from "../../../../Pages/Manage/BankDetails/AddBankData";
import { UserService } from "../../../../Services/Manage/UserService";
import { EnquiryService } from "../../../../Services/Manage/EnquiryService";
import { ENDPOINT } from "../../../../Services/ENDPOINT";
import CreatePayment from "../../../modals/CreatePayment";
import QuotationInvoiceTemplate from "../../template/QuotationInvoiceTemplate";
import QuotationInvoiceTemplateV2 from "../../template/QuotationInvoiceTemplateV2";
import QuotationProfessionalTemplate from "../../template/QuotationProfessionalTemplate";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";

const { Text } = Typography;

const scopeQuillModules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ align: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"],
  ],
};

const EditQuotationData = forwardRef(({
  quteData,
  Eqslected,
  initialData = [],
  selectedDate,
  eqData,
  followDate,
  validDate,
  quotationStatus,
  followUps: initialFollowUps = [],
  preparedBy,
  assignedTo,

}, ref) => {
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);

  //section
  const [sections, setSections] = useState([]);

  const [count, setCount] = useState(1);
  const [grandTotal, setGrandTotal] = useState(0);
  const [message, msgContc] = useMessage();

  const notesTabRef = useRef(null);

  const [letterHead, setLetterHead] = useState([]);
  const [selectedTCOption, setSelectedTCOption] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const [editedTCContent, setEditedTCContent] = useState("");
  const [tcModalOpen, setTcModalOpen] = useState(false);
  const [tempTcContent, setTempTcContent] = useState("");

  const [bankAc, setBankAc] = useState(null);
  const [bankAcOption, setBankAcOption] = useState([]);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [bankInitialValues, setBankInitialValues] = useState(null);


  const [dgSign, setDGsign] = useState(null);
  const [dgSignOption, setDGsignOption] = useState([]);

  //document
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [documentFiles, setDocumentFiles] = useState([]);


  const [paymentTerm, setPaymentTerm] = useState("50_advance");
  const [customPaymentTerm, setCustomPaymentTerm] = useState("");
  const [customPaymentOptions, setCustomPaymentOptions] = useState([]);
  const [notesToCustomer, setNotesToCustomer] = useState("");
  const [deliveryTimeline, setDeliveryTimeline] = useState("");

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [quotationNo, setQuotationNo] = useState(null);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const [selectedPrintQuNo, setSelectedPrintQuNo] = useState(null);

  const [scope, setScope] = useState("");
  const [exclusions, setExclusions] = useState("");
  const [assumptions, setAssumptions] = useState("");
  const [supportWarranty, setSupportWarranty] = useState("");
  const [internalNotes, setInternalNotes] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");
  const [activeTab, setActiveTab] = useState("scope");
  const [title, setTitle] = useState("");
  const [summaryDiscount, setSummaryDiscount] = useState(0);

  const [descOptions, setDescOptions] = useState([]);
  const [descSearch, setDescSearch] = useState("");
  const [showSummaryDiscount, setShowSummaryDiscount] = useState(false);
  const [editFollowUps, setEditFollowUps] = useState([]);
  const [followUpInput, setFollowUpInput] = useState({
    date: null,
    follow_up_type: null,
    summary: "",
  });

  const followUpTypeOptions = [
    { value: "Call", label: "Call" },
    { value: "Email", label: "Email" },
    { value: "Meeting", label: "Meeting" },
    { value: "Demo", label: "Demo" },
  ];

  const SummaryLine = ({ label, value }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 6,
        lineHeight: 1.3,
      }}
    >
      <Text style={{ color: "#6b7280", fontSize: 13 }}>{label}</Text>
      <Text style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>
        ₹ {Number(value || 0).toLocaleString("en-IN")}
      </Text>
    </div>
  );

  const getBase64Image = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });

  const getAllLetterhead = async () => {
    try {
      const request = await LetterService.getAllHead();
      setLetterHead(
        (request.data || []).map((item) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getBankAcOption = async () => {
    try {
      const request = await BankService.getAllBank();
      setBankAcOption(
        (request.data || []).map((item) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };
  const handleOpenAddBank = (initial = null) => {
    setBankInitialValues(initial);
    setBankModalOpen(true);
  };

  const handleBankSubmit = async (values) => {
    try {
      const payload = { ...values };

      let res;
      if (payload.id) {
        res = await BankService.updateBank(payload, payload.id);
      } else {
        res = await BankService.createBank(payload);
      }

      if (res && res.status) {
        message.success(res.message || "Bank saved");
        setBankModalOpen(false);
        await getBankAcOption();

        const newId = res.data?.id || payload.id;
        const newOpt = (bankAcOption || []).find((o) => Number(o.value) === Number(newId));
        if (newOpt) setBankAc(newOpt);
      } else {
        message.error(res?.message || "Failed to save bank");
      }
    } catch (err) {
      console.error(err);
      message.error("Bank save failed");
    }
  };


  const getAllTCData = async () => {
    try {
      const response = await LetterService.getAllTC();
      setSelectedTCOption(
        (response.data || []).map((item) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getDigitalSign = async () => {
    try {
      const response = await QuotationService.getDigitalSign();
      setDGsignOption(
        (response.data || []).map((item) => ({
          label: (
            <img
              src={`${ENDPOINT.base}/${item.image_path}`}
              alt={`Signature ${item.id}`}
              style={{ width: 100, height: "auto", objectFit: "contain" }}
            />
          ),
          value: item.id,
          title: `Signature ${item.id}`,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const buildDescOptions = async () => {
    try {
      const [prodRes, servRes, catRes] = await Promise.all([
        ServicetypeService.getAllProducts(),
        ServicetypeService.getAllServices(),
        ServicetypeService.getAllProductCat(),
      ]);

      const products = prodRes?.data || [];
      const services = servRes?.data || [];
      const cats = catRes?.data || [];

      const catMap = {};
      cats.forEach((c) => {
        catMap[String(c.id)] = c.name;
      });

      const prodGroups = {};
      products.forEach((p) => {
        const catName = catMap[String(p.cat_id)] || "Uncategorized";
        if (!prodGroups[catName]) prodGroups[catName] = [];
        prodGroups[catName].push({
          label: `${p.name}${p.sku ? ` (${p.sku})` : ""}`,
          value: `prod-${p.id}`,
          desc: p.name,
          description: p.description || "",
          hsn: p.sku || "",
          unit: p.unit || "",
          price: Number(p.unit_price) || 0,
        });
      });

      const productOptionGroups = Object.keys(prodGroups).map((catName) => ({
        label: `Product — ${catName}`,
        options: prodGroups[catName],
      }));

      const serviceOptions = {
        label: "Services",
        options: services.map((s) => ({
          label: `${s.service_name}${s.service_code ? ` (${s.service_code})` : ""}`,
          value: `serv-${s.id}`,
          desc: s.service_name,
          description: s.description || s.service_description || "",
          hsn: s.hsn_code || s.service_code || "",
          unit: s.unit || "",
          price: Number(s.unit_price) || 0,
        })),
      };

      setDescOptions([...productOptionGroups, serviceOptions]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setEditFollowUps(
      (initialFollowUps || []).map((item) => ({
        current_date: item.current_date
          ? dayjs(item.current_date).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        date: item.date || item.follow_date
          ? dayjs(item.date || item.follow_date)
          : null,
        summary: item.summary || "",
        follow_up_type: item.follow_up_type || null,
        follow_up_by: item.follow_up_by || "",
      }))
    );
  }, [initialFollowUps]);

  useEffect(() => {
    getAllLetterhead();
    getAllTCData();
    getBankAcOption();
    getDigitalSign();
    buildDescOptions();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      quotationNo: quteData?.qu_no,
      quotationDate: quteData?.date ? dayjs(quteData.date) : null,
      enquiry: quteData?.eq_no,
      gstNo: quteData?.cus_gst,
      tax_id: quteData?.tax_id,
      tax_type: quteData?.tax_type,
    });

    setScope(quteData?.scope || "");
    setTitle(quteData?.title || "");
    const savedPaymentTerm =
      quteData?.payment_terms ||
      quteData?.payment_term ||
      "50% Advance + 50% Before Delivery";

    const paymentTermMap = {
      "100% Advance": "100_advance",
      "50% Advance + 50% Before Delivery": "50_advance",
      "Milestone Based": "milestone",
    };

    if (paymentTermMap[savedPaymentTerm]) {
      setPaymentTerm(paymentTermMap[savedPaymentTerm]);
      setCustomPaymentTerm("");
      setCustomPaymentOptions([]);
    } else if (savedPaymentTerm) {
      setCustomPaymentOptions([savedPaymentTerm]);
      setPaymentTerm("custom_0");
      setCustomPaymentTerm("");
    } else {
      setPaymentTerm("50_advance");
      setCustomPaymentTerm("");
      setCustomPaymentOptions([]);
    }
    setNotesToCustomer(quteData?.notes_to_customer || "");
    setExclusions(quteData?.exclusions || "");
    setAssumptions(quteData?.assumptions || "");
    setSupportWarranty(quteData?.support_warranty || "");
    setCustomerNotes(quteData?.customer_notes || "");
    setInternalNotes(quteData?.internal_notes || "");
    setDeliveryTimeline(quteData?.delivery_timeline || "");

    const groupedSections = {};

    (initialData || []).forEach((item, index) => {
      const section = item.section_name || "General";

      if (!groupedSections[section]) {
        groupedSections[section] = [];
      }

      groupedSections[section].push({
        ...item,
        key: item.id || `row-${index}`,
        service_name: item.service_name || item.item_name || "",
        description: item.description || "",
        qty: Number(item.qty || 1),
        unit: item.unit || "",
        duration: item.duration || "",
        unitprice: Number(item.unitprice || 0),
        discount: Number(item.discount || 0),
        tax: Number(item.tax || 0),
        totalprice: Number(item.totalprice || 0),
        hsn_code: item.hsn_code || "",
      });
    });

    setDataSource(groupedSections["General"] || []);

    setSections(
      Object.keys(groupedSections)
        .filter((s) => s !== "General")
        .map((section) => ({
          key: `section-${Date.now()}-${section}`,
          title: section,
          rows: groupedSections[section],
        }))
    );

    setCount((initialData || []).length + 1);
  }, [quteData, initialData, form]);

  useEffect(() => {
    if (bankAcOption.length > 0 && quteData?.bank_id) {
      const selected = bankAcOption.find(
        (opt) => Number(opt.value) === Number(quteData.bank_id)
      );
      if (selected) setBankAc(selected);
    }
  }, [bankAcOption, quteData]);

  useEffect(() => {
    if (!quteData) return;

    const selected = selectedTCOption.find(
      (opt) => Number(opt.value) === Number(quteData?.tc_id)
    );

    const content =
      quteData?.tc_content ||
      selected?.data ||
      selected?.description ||
      selected?.tc_description ||
      selected?.terms_condition ||
      selected?.content ||
      selected?.details ||
      selected?.terms ||
      "";

    if (content) {
      setEditedTCContent(content);
      setTempTcContent(content);
      setSelectedValue({
        ...(selected || {}),
        label: selected?.label || "Saved Terms & Conditions",
        value: selected?.value || quteData?.tc_id || "saved_tc",
        id: selected?.id || quteData?.tc_id || null,
        data: content,
      });
    }
  }, [selectedTCOption, quteData]);

  useEffect(() => {
    if (dgSignOption.length > 0 && quteData?.sign_id) {
      const selected = dgSignOption.find(
        (opt) => Number(opt.value) === Number(quteData.sign_id)
      );
      if (selected) setDGsign(selected);
    }
  }, [dgSignOption, quteData]);

  useEffect(() => {
    calculateGrandTotal();
  }, [dataSource]);

  const numberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const g = ["", "Thousand", "Million", "Billion"];
    num = Math.round(Number(num || 0));
    if (num === 0) return "Zero";
    let str = "";
    let grp = 0;
    while (num > 0) {
      let chunk = num % 1000;
      if (chunk) {
        let chunkStr = "";
        if (chunk > 99) {
          chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
          chunk %= 100;
        }
        if (chunk > 19) {
          chunkStr += b[Math.floor(chunk / 10)] + " ";
          chunk %= 10;
        }
        if (chunk > 0) chunkStr += a[chunk] + " ";
        str = chunkStr + g[grp] + " " + str;
      }
      num = Math.floor(num / 1000);
      grp++;
    }
    return str.trim();
  };

  const calculateGrandTotal = () => {
    const total = dataSource.reduce(
      (sum, item) => sum + Number(item.totalprice || 0),
      0
    );
    setGrandTotal(total);
  };

  const recalcRow = (row) => {
    const qty = Number(row.qty || 0);
    const rate = Number(row.unitprice || 0);
    const discount = Number(row.discount || 0);
    const tax = Number(row.tax || 0);

    const base = qty * rate;
    const discountAmount = (base * discount) / 100;
    const taxable = base - discountAmount;
    const taxAmount = (taxable * tax) / 100;

    return {
      ...row,
      totalprice: Math.round(taxable + taxAmount),
    };
  };

  const handleChange = (key, field, value) => {
    setDataSource((prev) =>
      prev.map((item) =>
        item.key === key ? recalcRow({ ...item, [field]: value }) : item
      )
    );
  };

  const handleDelete = async (record) => {
    try {
      if (record?.id) {
        await QuotationService.deleteQuotation(record.id);
      }
      setDataSource((prev) => prev.filter((item) => item.key !== record.key));
    } catch (error) {
      console.error(error);
      message.error("Failed to delete item");
    }
  };

  //document
  const loadQuotationDocuments = async (qu_no) => {
    if (!qu_no) return;

    setLoadingDocuments(true);

    try {
      const response = await QuotationService.getQuotationDocuments(qu_no);

      if (response.status) {
        setExistingDocuments(response.data || []);
      }
    } catch (error) {
      console.error("Failed to load quotation documents", error);
    } finally {
      setLoadingDocuments(false);
    }
  };

  useEffect(() => {
    if (quteData?.qu_no) {
      loadQuotationDocuments(quteData.qu_no);
    }
  }, [quteData?.qu_no]);




  const handleAddSection = () => {
    setSections((prev) => [
      ...prev,
      {
        key: `section-${Date.now()}`,
        title: "",
        rows: [],
      },
    ]);
  };



  const handleNewAdd = () => {
    setDataSource((prev) => [
      ...prev,
      {
        key: `new-${count}`,
        service_name: "",
        description: "",
        qty: 1,
        unit: "",
        duration: "",
        unitprice: 0,
        discount: 0,
        tax: 0,
        totalprice: 0,
        hsn_code: "",
      },
    ]);
    setCount((prev) => prev + 1);
  };

  const getFilteredDescOptions = () => {
    const q = (descSearch || "").toLowerCase().trim();
    if (!q) return descOptions;
    return descOptions
      .map((group) => {
        const opts = (group.options || []).filter(
          (o) =>
            String(o.label || "").toLowerCase().includes(q) ||
            String(o.hsn || "").toLowerCase().includes(q)
        );
        return { ...group, options: opts };
      })
      .filter((group) => (group.options || []).length > 0);
  };

  const handleSelectDesc = (rowKey, val, option) => {
    setDataSource((prev) =>
      prev.map((item) => {
        if (item.key !== rowKey) return item;
        return recalcRow({
          ...item,
          service_name: option?.desc ?? item.service_name,
          description: option?.description ?? item.description,
          hsn_code: option?.hsn ?? item.hsn_code,
          unit: option?.unit ?? item.unit,
          unitprice: option?.price ?? item.unitprice,
        });
      })
    );
  };

  const showHsnColumn = dataSource.some(
    (item) => String(item.hsn_code || "").trim() !== ""
  );




  const handleSectionChange = (sectionKey, rowKey, field, value) => {
    setSections((prev) =>
      prev.map((section) => {
        if (section.key !== sectionKey) return section;

        return {
          ...section,
          rows: section.rows.map((row) => {
            if (row.key !== rowKey) return row;

            return recalcRow({
              ...row,
              [field]: value,
            });
          }),
        };
      })
    );
  };

  const handleSectionSelectDesc = (sectionKey, rowKey, val, option) => {
    setSections((prev) =>
      prev.map((section) => {
        if (section.key !== sectionKey) return section;

        return {
          ...section,
          rows: section.rows.map((row) => {
            if (row.key !== rowKey) return row;

            return recalcRow({
              ...row,
              service_name: option?.desc ?? row.service_name,
              description: option?.description ?? row.description,
              hsn_code: option?.hsn ?? row.hsn_code,
              unit: option?.unit ?? row.unit,
              unitprice: option?.price ?? row.unitprice,
            });
          }),
        };
      })
    );
  };

  const handleSectionDelete = async (sectionKey, record) => {
    try {
      if (record?.id) {
        await QuotationService.deleteQuotation(record.id);
      }

      setSections((prev) =>
        prev.map((section) => {
          if (section.key !== sectionKey) return section;

          return {
            ...section,
            rows: section.rows.filter((row) => row.key !== record.key),
          };
        })
      );
    } catch (error) {
      console.error(error);
      message.error("Failed to delete section item");
    }
  };







  const columns = [
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>#</span>,
      dataIndex: "key",
      width: 15,
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Item / Service</span>,
      dataIndex: "service_name",
      key: "service_name",
      width: 205,
      render: (text, record) => (
        <AutoComplete
          style={{ width: "100%" }}
          options={getFilteredDescOptions()}
          value={text}
          placeholder="Type product / service"
          filterOption={false}
          onSearch={(val) => setDescSearch(val)}
          onFocus={() => setDescSearch("")}
          onSelect={(val, option) => {
            setDescSearch("");
            handleSelectDesc(record.key, val, option);
          }}
          onChange={(val) => {
            setDescSearch(val);
            handleChange(record.key, "service_name", val);
          }}
        >
          <TextArea
            value={text}
            autoSize={{ minRows: 1, maxRows: 3 }}
            style={{ resize: "none", fontSize: 13 }}
          />
        </AutoComplete>
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Description</span>,
      dataIndex: "description",
      key: "description",
      width: 180,
      render: (text, record) => (
        <TextArea
          value={text}
          autoSize={{ minRows: 1, maxRows: 3 }}
          style={{ resize: "none", fontSize: 13 }}
          onChange={(e) => handleChange(record.key, "description", e.target.value)}
        />
      ),
    },
    ...(showHsnColumn
      ? [
        {
          title: <span style={{ fontSize: 12, fontWeight: 600 }}>HSN</span>,
          dataIndex: "hsn_code",
          width: 58,
          align: "center",
          render: (text, record) => (
            <Input
              size="small"
              value={text}
              style={{ width: "100%" }}
              onChange={(e) => handleChange(record.key, "hsn_code", e.target.value)}
            />
          ),
        },
      ]
      : []),
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Qty</span>,
      dataIndex: "qty",
      width: 45,
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "qty", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Unit</span>,
      dataIndex: "unit",
      width: 55,
      align: "center",
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          onChange={(e) => handleChange(record.key, "unit", e.target.value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Duration</span>,
      dataIndex: "duration",
      width: 60,
      align: "center",
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          placeholder=" "
          onChange={(e) => handleChange(record.key, "duration", e.target.value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Rate</span>,
      dataIndex: "unitprice",
      width: 70,
      align: "right",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "unitprice", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Discount %</span>,
      dataIndex: "discount",
      width: 60,
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          max={100}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "discount", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Tax %</span>,
      dataIndex: "tax",
      width: 52,
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "tax", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Amount</span>,
      dataIndex: "totalprice",
      width: 68,
      align: "right",
      render: (text) => (
        <Text strong style={{ fontSize: 12 }}>
          {Number(text || 0).toLocaleString("en-IN")}
        </Text>
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Action</span>,
      key: "action",
      width: 62,
      align: "center",
      render: (_, record) => (
        <Space size={0}>
          <Button type="text" size="small" icon={<EditOutlined />} />
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
            <Button type="text" size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];


  const getSectionColumns = (sectionKey) =>
    columns.map((col) => {
      if (col.key === "action") {
        return {
          ...col,
          render: (_, record) => (
            <Space size={0}>
              <Button type="text" size="small" icon={<EditOutlined />} />

              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => handleSectionDelete(sectionKey, record)}
              >
                <Button type="text" size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          ),
        };
      }

      if (!col.dataIndex) return col;

      if (col.dataIndex === "service_name") {
        return {
          ...col,
          render: (text, record) => (
            <AutoComplete
              style={{ width: "100%" }}
              options={getFilteredDescOptions()}
              value={text}
              placeholder="Type product / service"
              filterOption={false}
              onSearch={(val) => setDescSearch(val)}
              onFocus={() => setDescSearch("")}
              onSelect={(val, option) => {
                setDescSearch("");
                handleSectionSelectDesc(sectionKey, record.key, val, option);
              }}
              onChange={(val) =>
                handleSectionChange(sectionKey, record.key, "service_name", val)
              }
            >
              <TextArea
                value={text}
                autoSize={{ minRows: 1, maxRows: 3 }}
                style={{ resize: "none", fontSize: 13 }}
              />
            </AutoComplete>
          ),
        };
      }

      return {
        ...col,
        render: (text, record, index) => {
          if (col.dataIndex === "key") return index + 1;

          if (["description", "unit", "duration", "hsn_code"].includes(col.dataIndex)) {
            return (
              <Input
                size="small"
                value={text}
                onChange={(e) =>
                  handleSectionChange(
                    sectionKey,
                    record.key,
                    col.dataIndex,
                    e.target.value
                  )
                }
              />
            );
          }

          if (["qty", "unitprice", "discount", "tax"].includes(col.dataIndex)) {
            return (
              <InputNumber
                size="small"
                min={0}
                controls={false}
                value={text}
                style={{ width: "100%" }}
                onChange={(value) =>
                  handleSectionChange(
                    sectionKey,
                    record.key,
                    col.dataIndex,
                    value
                  )
                }
              />
            );
          }

          if (col.dataIndex === "totalprice") {
            return (
              <Text strong style={{ fontSize: 12 }}>
                {Number(text || 0).toLocaleString("en-IN")}
              </Text>
            );
          }

          return col.render ? col.render(text, record, index) : text;
        },
      };
    });






  const handleAddFollowUp = () => {
    if (!followUpInput.date && !followUpInput.follow_up_type && !followUpInput.summary) return;

    const user = JSON.parse(localStorage.getItem("ome_user") || "{}");

    setEditFollowUps((prev) => [
      ...prev,
      {
        current_date: dayjs().format("YYYY-MM-DD"),
        date: followUpInput.date,
        follow_up_type: followUpInput.follow_up_type,
        summary: followUpInput.summary,
        follow_up_by: user?.name || user?.user_name || user?.uid || "",
      },
    ]);

    setFollowUpInput({
      date: null,
      follow_up_type: null,
      summary: "",
    });
  };

  const handleSave = async () => {
    try {
      if (!dataSource || dataSource.length <= 0) {
        return message.warning("Please add contents");
      }

      const request = form.getFieldsValue();
      const user = await UserService.getOmeUser();

      const quNo = request.quotationNo || quteData?.qu_no;

      const mainRows = dataSource.map(({ key, ...item }) => ({
        id: item.id,
        service_name: item.service_name || null,
        description: item.description || null,
        qty: item.qty || 1,
        unit: item.unit || null,
        duration: item.duration || null,
        discount: item.discount || 0,
        hsn_code: item.hsn_code || null,
        tax: item.tax || 0,
        unitprice: item.unitprice || 0,
        totalprice: item.totalprice || 0,
        qu_no: quNo,
        section_name: "General",
      }));

      const sectionRows = sections.flatMap((section) =>
        section.rows.map(({ key, ...item }) => ({
          id: item.id,
          service_name: item.service_name || null,
          description: item.description || null,
          qty: item.qty || 1,
          unit: item.unit || null,
          duration: item.duration || null,
          discount: item.discount || 0,
          hsn_code: item.hsn_code || null,
          tax: item.tax || 0,
          unitprice: item.unitprice || 0,
          totalprice: item.totalprice || 0,
          qu_no: quNo,
          section_name: section.title || "Untitled Section",
        }))
      );

      const formattedData = [...mainRows, ...sectionRows];

      const paymentTermLabels = {
        "100_advance": "100% Advance",
        "50_advance": "50% Advance + 50% Before Delivery",
        milestone: "Milestone Based",
      };

      let finalPaymentTerm = paymentTermLabels[paymentTerm] || "";

      if (String(paymentTerm).startsWith("custom_")) {
        const idx = Number(String(paymentTerm).replace("custom_", ""));
        finalPaymentTerm = customPaymentOptions[idx] || quteData?.payment_terms || "";
      }

      if (!finalPaymentTerm) {
        finalPaymentTerm = quteData?.payment_terms || "50% Advance + 50% Before Delivery";
      }

      const data_insert = {
        qu_no: request.quotationNo || quteData?.qu_no,
        title: title || null,
        tax_id: request.tax_id,
        tax_type: request.tax_type,
        eq_no: quteData?.eq_no || eqData?.eq_id || null,
        quotation_status: quotationStatus || "Draft",
        date: selectedDate || quteData?.date || null,
        valid_date: validDate || null,
        expected_close_date: followDate || null,
        sub_total: subTotal || 0,
        summary_discount: summaryDiscount || 0,
        taxable_amount: taxableAmount || 0,
        cgst_amount: cgstAmount || 0,
        sgst_amount: sgstAmount || 0,
        round_off: roundOff || 0,
        grand_total_saved: roundedTotal || 0,
        n_follow_up:
          editFollowUps.length > 0
            ? dayjs(editFollowUps[editFollowUps.length - 1].date).format("YYYY-MM-DD")
            : followDate || null,

        follow_ups: editFollowUps.map((item) => ({
          current_date: item.current_date
            ? dayjs(item.current_date).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          follow_date: item.date ? dayjs(item.date).format("YYYY-MM-DD") : null,
          summary: item.summary || "",
          follow_up_type: item.follow_up_type || null,
          follow_up_by: item.follow_up_by || null,
        })),
        cus_gst: request?.gstNo,
        tc_id: selectedValue?.id || quteData?.tc_id || null,
        tc_content:
          editedTCContent ||
          selectedValue?.data ||
          quteData?.tc_content ||
          "",
        sign_id: dgSign?.id || null,
        bank_id: bankAc?.id || bankAc?.value || null,
        scope: scope || null,
        exclusions: exclusions || null,
        assumptions: assumptions || null,
        support_warranty: supportWarranty || null,
        internal_notes: internalNotes || null,
        customer_notes: customerNotes || null,
        payment_terms: finalPaymentTerm,
        notes_to_customer: notesToCustomer || null,
        delivery_timeline: deliveryTimeline || null,
        added_by: user?.uid,
        prepared_by: preparedBy || quteData?.prepared_by || user?.uid || null,
        assigned_to: assignedTo || eqData?.assigned_to || quteData?.assigned_to || null,
        probability: probabilityPercent || null,
      };

      const customerInfoPayload = {
        name: eqData?.name || null,
        company_name: eqData?.company_name || null,
        mobile_no:
          eqData?.mobile_no ||
          eqData?.contact_phone ||
          eqData?.contact_whatsapp ||
          null,
        email: eqData?.email || eqData?.contact_email || null,
        gstin: eqData?.gstin || null,
        address: eqData?.address || eqData?.location_city || null,
      };

      const requirementInfoPayload = {
        requirement: eqData?.eq_description || eqData?.summary || null,
        business_type: eqData?.industry_type || eqData?.business_type || null,
        no_of_users: eqData?.no_of_users || eqData?.number_of_employees || null,
        expected_start_date:
          eqData?.expected_start_date || eqData?.expected_go_live_date || null,
        remarks: eqData?.note || null,
        service_items: eqData?.service_items || [],
        product_items: eqData?.product_items || [],
      };
      const send_both = {
        formattedData,
        quotation_insert: data_insert,
        customer_info: customerInfoPayload,
        requirement_info: requirementInfoPayload,
      };

      const response = await QuotationService.updateQuotation(
        send_both,
        request.quotationNo || quteData?.qu_no
      );

      if (response.status && documentFiles.length > 0) {
        const fd = new FormData();

        documentFiles.forEach((file) => {
          fd.append("documents", file);
        });

        fd.append("added_by", user?.uid || "");

        await QuotationService.uploadQuotationDocuments(
          request.quotationNo || quteData?.qu_no,
          fd
        );

        setDocumentFiles([]);
        await loadQuotationDocuments(request.quotationNo || quteData?.qu_no);
      }

      if (response.status) message.success(response.message);
      else message.error(response.message);
    } catch (error) {
      console.error(error);
      message.error("Failed to update quotation");
    }
  };

  const handlePrintInvoice = async (qu_no, templateType = "v1") => {
    try {
      const quotationRes = await QuotationService.getAllQuotationById(qu_no);

      let orgDetailsToUse = null;
      try {
        const orgRes = await LetterService.getAllFooter();
        orgDetailsToUse = (orgRes.data || [])[0] || null;
      } catch (e) {
        console.error("getAllFooter ERROR:", e);
      }

      const quotation = quotationRes?.data?.quotation;
      const quotationData = [
        ...dataSource.map((item) => ({
          ...item,
          section_name: "General",
        })),

        ...sections.flatMap((section) =>
          section.rows.map((item) => ({
            ...item,
            section_name: section.title || "Untitled Section",
          }))
        ),
      ];

      let enquiry;
      const isManual = quotation?.eq_no === quotation?.qu_no;

      if (isManual) {
        const cust = quotationRes?.data?.customer || {};
        enquiry = {
          name: cust.name || "-",
          address: cust.address || "-",
          mobile_no: cust.mobile_no || "-",
          currency: "INR",
        };
      } else {
        const enquiryRes = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
        enquiry = enquiryRes?.data;
      }

      const headerImageObj = letterHead.find(
        (lh) => String(lh.tag || "").toLowerCase() === "header"
      );
      const footerImageObj = letterHead.find(
        (lh) => String(lh.tag || "").toLowerCase() === "footer"
      );
      const watermarkImageObj = letterHead.find(
        (lh) => String(lh.tag || "").toLowerCase() === "watermark"
      );

      const headerBase64 = headerImageObj
        ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`)
        : "";
      const footerBase64 = footerImageObj
        ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`)
        : "";

      let footerAspectRatio = null;
      if (footerBase64) {
        footerAspectRatio = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(img.width / img.height);
          img.onerror = () => resolve(null);
          img.src = footerBase64;
        });
      }

      const dgSignBase64 = dgSign
        ? await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`)
        : "";

      let dgSignAspectRatio = null;
      if (dgSignBase64) {
        dgSignAspectRatio = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(img.width / img.height);
          img.onerror = () => resolve(null);
          img.src = dgSignBase64;
        });
      }

      const watermarkBase64 = watermarkImageObj
        ? await getBase64Image(`${ENDPOINT.base}/${watermarkImageObj.image_url}`)
        : "";

      const templateProps = {
        headerBase64,
        footerBase64,
        footerAspectRatio,
        dgSignBase64,
        dgSignAspectRatio,
        watermarkBase64,
        quotation,
        enquiry,
        quotationData,
        invoice_date: quotation.date,
        grandTotal,
        numberToWords,
        bankAc,
        selectedValue,
        orgDetails: orgDetailsToUse,
        tax_type: form.getFieldValue("tax_type"),
        tax_id: form.getFieldValue("tax_id"),
        type: "QUOTATION",
        currency: enquiry?.currency || "INR",
        paymentTermOptions: [
          "100% Advance",
          "50% Advance + 50% Before Delivery",
          "Milestone Based",
          ...customPaymentOptions,
        ],
        selectedPaymentTerm:
          paymentTerm === "100_advance"
            ? "100% Advance"
            : paymentTerm === "50_advance"
              ? "50% Advance + 50% Before Delivery"
              : paymentTerm === "milestone"
                ? "Milestone Based"
                : customPaymentOptions[Number(String(paymentTerm).replace("custom_", ""))] ||
                quotation?.payment_terms,
      };

const pdfDoc =
        templateType === "professional"
          ? QuotationProfessionalTemplate(templateProps)
          : templateType === "v2"
            ? QuotationInvoiceTemplateV2(templateProps)
            : QuotationInvoiceTemplate(templateProps);

      pdfDoc.save(`${quotation.qu_no || "Quotation"}.pdf`);
      return pdfDoc;
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF");
    }
  };

 const handleSendQuotationEmail = async () => {
    const newTab = window.open("", "_blank");
    try {
      const quNo = quteData?.qu_no;
      const pdfDoc = await handlePrintInvoice(quNo, "professional");
      if (!pdfDoc) { if (newTab) newTab.close(); return; }

const toEmail = eqData?.email || eqData?.contact_email || "";
const customerName = eqData?.name || eqData?.company_name || "";
const to = encodeURIComponent(toEmail);
const subject = encodeURIComponent(`Quotation ${quNo}`);
const body = encodeURIComponent(
  `Hello ${customerName},\n\nPlease find attached quotation ${quNo}.\n\nThank you for your business.`
);
const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`;
      if (newTab) {
        newTab.location.href = gmailUrl;
      } else {
        window.open(gmailUrl, "_blank");
      }
      message.success("PDF downloaded — attach it in Gmail.");
    } catch (e) {
      if (newTab) newTab.close();
      console.error(e);
      message.error("Failed to send quotation.");
    }
  };

  const handleAddPayment = () => {
    const request = form.getFieldsValue();
    setQuotationNo(request.quotationNo || quteData?.qu_no);
    setPaymentModalOpen(true);
  };

  const handleClear = () => {
    setDataSource([]);
  };





  const quotationAge = quteData?.date
    ? `${dayjs().diff(dayjs(quteData.date), "day")} Days`
    : "-";

  const avgTax =
    dataSource.length > 0
      ? Number(dataSource[0]?.tax || 0)
      : 0;

  const cgstPercent = avgTax / 2;
  const sgstPercent = avgTax / 2;

  const subTotal = dataSource.reduce((sum, item) => {
    const qty = Number(item.qty || 0);
    const rate = Number(item.unitprice || 0);
    const discount = Number(item.discount || 0);

    const base = qty * rate;
    const discountAmount = (base * discount) / 100;

    return sum + (base - discountAmount);
  }, 0);

  const taxableAmount = subTotal - Number(summaryDiscount || 0);

  const cgstAmount = taxableAmount * (cgstPercent / 100);
  const sgstAmount = taxableAmount * (sgstPercent / 100);

  const totalBeforeRound = taxableAmount + cgstAmount + sgstAmount;
  const roundedTotal = Math.round(totalBeforeRound);
  const roundOff = roundedTotal - totalBeforeRound;

  const probabilityMap = {
    Draft: 10,
    Reviewed: 10,
    Sent: 20,
    Viewed: 40,
    Negotiation: 70,
    Negotiated: 70,
    Approved: 90,
    Converted: 100,
  };

  const probabilityPercent = probabilityMap[quotationStatus] || 10;

  const quotationValue = roundedTotal;

  const expectedRevenue = Math.round(
    quotationValue * (probabilityPercent / 100)
  );

  const weightedValue = Math.round(
    quotationValue * (probabilityPercent / 100)
  );

  const currentFollowUp =
    editFollowUps.length > 0
      ? editFollowUps[editFollowUps.length - 1]
      : null;



useImperativeHandle(ref, () => ({
    handleSave,
    handlePrintInvoice,
    handleSendQuotationEmail,
  }));



  //limittaion
  const limitRichText = (value, setter) => {
    const plainText = value
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const pointCount = (value.match(/<li/g) || []).length;

    if (plainText.length > 344) {
      message.warning("Maximum 344 letters allowed");
      return;
    }

    if (pointCount > 6) {
      message.warning("Maximum 6 points allowed");
      return;
    }

    setter(value);
  };


  return (
    <>
      {msgContc}

      <style>{`
        .scope-quill .quill {
          border: none;
          background: #fff;
        }
        .scope-quill .ql-toolbar.ql-snow {
          border: none;
          border-bottom: 1px solid #f0f0f0;
          background: #fafafa;
          padding: 8px 12px;
        }
        .scope-quill .ql-container.ql-snow {
          border: none;
          font-size: 14px;
        }
        .scope-quill .ql-editor {
          min-height: 220px;
          padding: 14px 16px;
          line-height: 1.6;
        }
        .scope-quill .ql-editor.ql-blank::before {
          left: 16px;
          color: #bfbfbf;
          font-style: normal;
        }
      `}</style>



      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={20}>
          <Card style={{ borderRadius: 12 }} bodyStyle={{ padding: "4px 14px 14px 14px", }}>
            <div style={{ marginBottom: 14 }}>
              <Text
                strong
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "rgba(11, 93, 148, 0.95)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <UnorderedListOutlined style={{ marginRight: 8 }} />
                Quotation Items
              </Text>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 12,
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <Space wrap>
                  <Button
                    size="small"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={handleNewAdd}
                    style={{
                      backgroundColor: "rgba(11, 93, 148, 0.95)",
                      borderColor: "rgba(11, 93, 148, 0.95)",
                    }}
                  >
                    Add Item
                  </Button>
                  <Button
                    size="small"
                    icon={<PlusOutlined />}
                    onClick={handleAddSection}
                  >
                    Add Section
                  </Button>
                </Space>

                <Space wrap>
                  <Button
                    size="small"
                    onClick={() => setShowSummaryDiscount(true)}
                  >
                    Apply Discount
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      setActiveTab("customer_notes");

                      setTimeout(() => {
                        notesTabRef.current?.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }, 100);
                    }}
                  >
                    Add Note
                  </Button>
                </Space>
              </div>
            </div>

            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              rowKey="key"
              size="small"
              tableLayout="fixed"
            />


            <Button
              type="link"
              icon={<PlusOutlined />}
              onClick={handleNewAdd}
              disabled={!Eqslected}
              style={{ marginTop: 12, paddingLeft: 0, fontSize: 12, fontWeight: 600, color: "rgba(11, 93, 148, 0.95)", }}
            >
              Add New Item
            </Button>


            {sections.map((section) => (
              <div key={section.key} style={{ marginTop: 20, border: "1px solid #f0f0f0", borderRadius: 8, padding: 10 }}>
                <Input
                  size="small"
                  placeholder="Enter Section Title"
                  value={section.title}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSections((prev) =>
                      prev.map((sec) =>
                        sec.key === section.key ? { ...sec, title: value } : sec
                      )
                    );
                  }}
                  style={{ marginBottom: 10, fontWeight: 600 }}
                />

                <Table
                  dataSource={section.rows}
                  columns={getSectionColumns(section.key)}
                  pagination={false}
                  rowKey="key"
                  size="small"
                  tableLayout="fixed"
                />

                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setSections((prev) =>
                      prev.map((sec) =>
                        sec.key === section.key
                          ? {
                            ...sec,
                            rows: [
                              ...sec.rows,
                              {
                                key: `section-row-${Date.now()}`,
                                service_name: "",
                                description: "",
                                qty: 1,
                                unit: "",
                                duration: "",
                                unitprice: 0,
                                discount: 0,
                                tax: 0,
                                totalprice: 0,
                                hsn_code: "",
                              },
                            ],
                          }
                          : sec
                      )
                    );
                  }}
                >
                  Add Item In Section
                </Button>
              </div>
            ))}




          </Card>
        </Col>

        <Col xs={24} lg={4}>
          <Card
            title={<span style={{ fontSize: 16, fontWeight: 600 }}>Price Summary</span>}
            style={{ borderRadius: 12, height: "100%" }}
            bodyStyle={{ padding: 12 }}
            headStyle={{ minHeight: 42, padding: "0 12px" }}
          >
            <SummaryLine label="Sub Total" value={subTotal} />

            {showSummaryDiscount && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <Text style={{ fontSize: 13, color: "#6b7280" }}>
                  Discount (₹)
                </Text>

                <InputNumber
                  size="small"
                  min={0}
                  value={summaryDiscount}
                  onChange={(val) => setSummaryDiscount(val || 0)}
                  style={{ width: 90 }}
                />
              </div>
            )}
            <Divider style={{ margin: "8px 0" }} />
            <SummaryLine label="Taxable Amount" value={taxableAmount} />
            <SummaryLine label={`CGST (${cgstPercent}%)`} value={cgstAmount} />
            <SummaryLine label={`SGST (${sgstPercent}%)`} value={sgstAmount} />
            <SummaryLine label="Round Off" value={roundOff.toFixed(2)} />
            <Divider style={{ margin: "8px 0" }} />

            <div style={{ marginTop: 10 }}>
              <Text style={{ color: "#6b7280", fontWeight: 700 }}>Grand Total</Text>
              <div
                style={{
                  color: "rgba(11, 93, 148, 0.95)",
                  fontSize: 16,
                  fontWeight: 700,
                  marginTop: 6,
                }}
              >
                ₹ {roundedTotal.toLocaleString("en-IN")}
              </div>
              <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
                {numberToWords(roundedTotal)} Only
              </Text>
            </div>
          </Card>
        </Col>

        <Col xs={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: "rgba(11, 93, 148, 0.95)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <SafetyCertificateOutlined style={{ marginRight: 8 }} />
                      Terms & Conditions
                    </span>

                    <Button
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => {
                        setTempTcContent(editedTCContent || selectedValue?.data || "");
                        setTcModalOpen(true);
                      }}
                    />
                  </div>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{ minHeight: 42, padding: "0 12px" }}
                bodyStyle={{ padding: "10px 12px", fontSize: 13 }}
              >
                <Select
                  size="small"
                  placeholder="Select Terms & Conditions"
                  value={selectedValue?.value}
                  style={{ width: "100%", marginBottom: 10 }}
                  options={selectedTCOption}
                  onChange={(value, option) => {
                    const content =
                      option?.data ||
                      option?.description ||
                      option?.tc_description ||
                      option?.terms_condition ||
                      option?.content ||
                      option?.details ||
                      option?.terms ||
                      "";

                    setEditedTCContent(content);
                    setSelectedValue({
                      ...option,
                      data: content,
                    });
                  }}
                />

                {selectedValue ? (
                  <div style={{ fontSize: 13, lineHeight: 1.6, color: "#111827" }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `
                          <style>
                            ul,ol{margin:0;padding-left:18px;}
                            li{margin-bottom:6px;}
                            p{margin:0;}
                          </style>
                          ${editedTCContent ||
                          selectedValue.data ||
                          selectedValue.description ||
                          selectedValue.tc_description ||
                          selectedValue.terms_condition ||
                          selectedValue.content ||
                          selectedValue.details ||
                          selectedValue.terms ||
                          ""
                          }
                        `,
                      }}
                    />
                  </div>
                ) : (
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Please select Terms & Conditions
                  </Text>
                )}
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <WalletOutlined style={{ marginRight: 8 }} />
                    Payment Terms
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                  fontSize: 13,
                }}
              >
                <Radio.Group
                  value={paymentTerm}
                  onChange={(e) => setPaymentTerm(e.target.value)}
                >
                  <Space direction="vertical" size={4}>
                    <Radio value="100_advance">100% Advance</Radio>

                    <Radio value="50_advance">
                      50% Advance + 50% Before Delivery
                    </Radio>

                    <Radio value="milestone">
                      Milestone Based
                    </Radio>

                    {customPaymentOptions.map((item, index) => (
                      <Radio
                        key={index}
                        value={`custom_${index}`}
                      >
                        {item}
                      </Radio>
                    ))}

                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        marginTop: 8,
                      }}
                    >
                      <Input
                        size="small"
                        placeholder="Add custom payment term"
                        value={customPaymentTerm}
                        onChange={(e) =>
                          setCustomPaymentTerm(e.target.value)
                        }
                      />

                      <Button
                        size="small"
                        type="primary"
                        onClick={() => {
                          if (!customPaymentTerm?.trim()) return;

                          setCustomPaymentOptions((prev) => [
                            ...prev,
                            customPaymentTerm,
                          ]);

                          setPaymentTerm(
                            `custom_${customPaymentOptions.length}`
                          );

                          setCustomPaymentTerm("");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </Space>
                </Radio.Group>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BankOutlined style={{ marginRight: 8 }} />
                    Bank Details
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{ minHeight: 42, padding: "0 12px" }}
                bodyStyle={{ padding: "10px 12px", fontSize: 13 }}
              >
                <Select
                  size="small"
                  placeholder="Select bank account"
                  value={bankAc?.value}
                  style={{ width: "100%", marginBottom: 8 }}
                  options={bankAcOption}
                  onChange={(value, option) => setBankAc(option)}
                />


                {bankAc ? (
                  <>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>Bank Name:</b> {bankAc.bank_name}
                    </p>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>IFSC Code:</b> {bankAc.ifsc_code}
                    </p>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>Account Name:</b> {bankAc.holder_name}
                    </p>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>Account No:</b> {bankAc.ac_no}
                    </p>
                  </>
                ) : (
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Please select a bank account
                  </Text>
                )}
                <div
                  onClick={() => handleOpenAddBank(null)}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: 12,
                    cursor: "pointer",
                    color: "#7c5cff",
                    fontWeight: 500,
                    fontSize: 13,
                  }}
                >
                  <PlusOutlined
                    style={{
                      fontSize: 12,
                      color: "#7c5cff",
                    }}
                  />
                  <span>Add Another Bank Account</span>
                </div>

              </Card>
              <Modal
                title={bankInitialValues?.id ? "Edit Bank" : "Add Bank"}
                open={bankModalOpen}
                onCancel={() => setBankModalOpen(false)}
                footer={null}
              >
                <AddBankData
                  initialValues={bankInitialValues}
                  onSubmit={handleBankSubmit}
                  onCancel={() => setBankModalOpen(false)}
                />
              </Modal>

            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SafetyCertificateOutlined style={{ marginRight: 8 }} />
                    Signature
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{ minHeight: 42, padding: "0 12px" }}
                bodyStyle={{ padding: "10px 12px", fontSize: 13 }}
              >
                <Select
                  size="small"
                  placeholder="Select Signature"
                  value={dgSign?.value}
                  style={{ width: "100%", marginBottom: 8 }}
                  options={dgSignOption}
                  optionRender={(option) => option.data.label}
                  fieldNames={{ label: "title", value: "value" }}
                  onChange={(value, option) => setDGsign(option)}
                />
                {dgSign ? (
                  <div style={{ textAlign: "center", marginTop: 6 }}>
                    <img
                      src={`${ENDPOINT.base}/${dgSign.image_path}`}
                      alt="Signature"
                      style={{ maxWidth: "100%", maxHeight: 90, objectFit: "contain" }}
                    />
                  </div>
                ) : (
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Please select a signature
                  </Text>
                )}
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FileTextOutlined style={{ marginRight: 8 }} />
                    Notes To Customer
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{ minHeight: 42, padding: "0 12px" }}
                bodyStyle={{ padding: "10px 12px", fontSize: 13 }}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Enter notes to customer"
                  value={notesToCustomer}
                  onChange={(e) => setNotesToCustomer(e.target.value)}
                  style={{ fontSize: 13, resize: "none" }}
                />
              </Card>
            </Col>
          </Row>
        </Col>

        <Col xs={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={16}>
              <Card ref={notesTabRef} style={{ borderRadius: 12 }} bodyStyle={{ padding: 0 }}>
                <Tabs
                  activeKey={activeTab}
                  onChange={setActiveTab}
                  items={[
                    {
                      key: "scope",
                      label: "Scope of Work",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={scope}
                            onChange={(value) => limitRichText(value, setScope)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "exclusions",
                      label: "Exclusions",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={exclusions}
                            onChange={(value) => limitRichText(value, setExclusions)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "assumptions",
                      label: "Assumptions",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={assumptions}
                            onChange={(value) => limitRichText(value, setAssumptions)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "support",
                      label: "Support & Warranty",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={supportWarranty}
                            onChange={(value) => limitRichText(value, setSupportWarranty)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "documents",
                      label: "Documents",
                      children: (
                        <div style={{ padding: 16 }}>
                          {existingDocuments.length > 0 && (
                            <div style={{ marginBottom: 18 }}>
                              <Typography.Text strong>
                                Saved Documents
                              </Typography.Text>
                              <div style={{ marginTop: 8 }}>
                                {existingDocuments.map((doc) => (
                                  <div key={doc.id} style={{ marginBottom: 6 }}>
                                    <a
                                      href={`${ENDPOINT.base}/${doc.file_path}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {doc.file_name}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          <Upload.Dragger
                            multiple
                            beforeUpload={(file) => {
                              setDocumentFiles((prev) => [...prev, file]);
                              return false;
                            }}
                            onRemove={(file) => {
                              setDocumentFiles((prev) =>
                                prev.filter((item) => item.uid !== file.uid)
                              );
                            }}
                            fileList={documentFiles}
                          >
                            <p>Drag & Drop files here or click to upload</p>
                          </Upload.Dragger>
                        </div>
                      ),
                    },

                    {
                      key: "notes",
                      label: "Internal Notes",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={internalNotes}
                            onChange={(value) => limitRichText(value, setInternalNotes)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },

                    {
                      key: "delivery_timeline",
                      label: "Delivery Timeline",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={deliveryTimeline}
                            onChange={(value) => limitRichText(value, setDeliveryTimeline)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "customer_notes",
                      label: "Customer Notes",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={customerNotes}
                            onChange={(value) => limitRichText(value, setCustomerNotes)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </Card>
            </Col>

            <Col xs={24} lg={8}>
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#111827",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BarChartOutlined style={{ marginRight: 8, color: "#0B5D94" }} />
                    Quotation Analytics
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{ minHeight: 42, padding: "0 12px", background: "#fff" }}
                bodyStyle={{ padding: 12 }}
              >
                <Row gutter={[12, 12]}>
                  {[
                    {
                      label: "Total Value",
                      value: `₹ ${roundedTotal.toLocaleString("en-IN")}`,
                    },
                    {
                      label: "Probability",
                      value: `${probabilityPercent}%`,
                      color:
                        probabilityPercent >= 90
                          ? "#16a34a"
                          : probabilityPercent >= 40
                            ? "#f59e0b"
                            : "#ef4444",
                    },
                    {
                      label: "Expected Revenue",
                      value: `₹ ${expectedRevenue.toLocaleString("en-IN")}`,
                    },
                    {
                      label: "Weighted Value",
                      value: `₹ ${weightedValue.toLocaleString("en-IN")}`,
                    },
                    {
                      label: "Quotation Age",
                      value: quotationAge,
                    },
                    { label: "Last Activity", value: dayjs().format("DD MMM YYYY") },
                    {
                      label: "Next Follow-up",
                      value: currentFollowUp?.date
                        ? dayjs(currentFollowUp.date).format("DD MMM YYYY")
                        : "-",
                    },
                  ].map((item, index) => (
                    <Col xs={24} sm={12} md={index > 3 ? 8 : 6} key={index}>
                      <div
                        style={{
                          border: "1px solid #eef0f5",
                          borderRadius: 10,
                          padding: "12px 10px",
                          minHeight: 68,
                          background: "#fff",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 11,
                            fontWeight: 400,
                            color: "#9ca3af",
                            display: "block",
                            marginBottom: 6,
                          }}
                        >
                          {item.label}
                        </Text>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: item.color || "#2a2b2c",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      <Card
        title={
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "rgba(11, 93, 148, 0.95)",
            }}
          >
            Follow-up Details
          </span>
        }
        style={{ marginTop: 10, borderRadius: 8 }}
        headStyle={{
          padding: "4px 10px",
          minHeight: 36,
        }}
        bodyStyle={{
          padding: "6px 10px",
        }}
      >
        <Row gutter={[8, 8]}>
          <Col xs={24} md={4}>
            <Form.Item label="Follow-up Date" style={{ marginBottom: 0 }}>
              <DatePicker
                size="small"
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                value={followUpInput.date}
                onChange={(value) =>
                  setFollowUpInput({ ...followUpInput, date: value })
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={4}>
            <Form.Item label="Follow-up Type" style={{ marginBottom: 0 }}>
              <Select
                size="small"
                allowClear
                placeholder="Select type"
                options={followUpTypeOptions}
                value={followUpInput.follow_up_type}
                onChange={(value) =>
                  setFollowUpInput({
                    ...followUpInput,
                    follow_up_type: value,
                  })
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={16}>
            <Form.Item label="Summary" style={{ marginBottom: 0 }}>
              <Input.TextArea
                rows={1}
                style={{ minHeight: 32 }}
                placeholder="Enter follow-up summary"
                value={followUpInput.summary}
                onChange={(e) =>
                  setFollowUpInput({
                    ...followUpInput,
                    summary: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: 8 }}>
          <Col>
            <Button
              type="primary"
              size="small"
              onClick={handleAddFollowUp}
              style={{
                backgroundColor: "rgba(14, 93, 146, 0.95)",
                borderColor: "rgba(14, 93, 146, 0.95)",
              }}
            >
              + Next Follow-Up
            </Button>
          </Col>
        </Row>
        {editFollowUps.length > 0 && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: 12,
            }}
          >
            <thead>
              <tr style={{ background: "#fafafa" }}>
                <th style={{ textAlign: "left", padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0", width: "18%" }}>
                  Follow-up Date
                </th>
                <th style={{ textAlign: "left", padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0", width: "18%" }}>
                  Follow-up Type
                </th>
                <th style={{ textAlign: "left", padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                  Summary
                </th>
                <th style={{ textAlign: "left", padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0", width: "18%" }}>
                  Follow-up By
                </th>
              </tr>
            </thead>

            <tbody>
              {editFollowUps.map((item, index) => (
                <tr key={index}>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.date ? dayjs(item.date).format("DD-MM-YYYY") : "-"}
                  </td>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.follow_up_type || "-"}
                  </td>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.summary || "-"}
                  </td>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.follow_up_by || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>

      <Modal
        width={800}
        title={<Typography.Title level={4}>Add Payment for: {quotationNo}</Typography.Title>}
        open={paymentModalOpen}
        onCancel={() => setPaymentModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        {quotationNo && <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />}
      </Modal>

      <Modal
        title="Choose Quotation Template"
        open={templateModalOpen}
        onCancel={() => setTemplateModalOpen(false)}
        footer={null}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            block
            size="large"
            type="primary"
            onClick={() => {
              setTemplateModalOpen(false);
              handlePrintInvoice(selectedPrintQuNo, "v1");
            }}
          >
            Template 1
          </Button>

          <Button
            block
            size="large"
            type="primary"
            onClick={() => {
              setTemplateModalOpen(false);
              handlePrintInvoice(selectedPrintQuNo, "v2");
            }}
          >
            Template 2
          </Button>
        </Space>
      </Modal>


      <Modal
        title="Edit Terms & Conditions"
        open={tcModalOpen}
        onCancel={() => setTcModalOpen(false)}
        onOk={() => {
          setEditedTCContent(tempTcContent);
          setSelectedValue((prev) => ({
            ...prev,
            data: tempTcContent,
          }));
          setTcModalOpen(false);
        }}
        width={900}
      >
        <ReactQuill
          theme="snow"
          value={tempTcContent}
          onChange={(value) => limitRichText(value, setTempTcContent)}
          modules={scopeQuillModules}
        />
        <div
          style={{
            textAlign: "right",
            fontSize: 12,
            color: "#999",
            marginTop: 5,
          }}
        >
          {scope
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim().length}{" "}
          / 344
        </div>

      </Modal>
    </>
  );
});

export default EditQuotationData;
